import { createFileRoute } from '@tanstack/react-router';

import { PresentationAppearancePage } from '../features/presentations/appearance/presentation-appearance-page';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance',
)({ component: RouteComponent });

function RouteComponent() {
  const params = Route.useParams();
  return <PresentationAppearancePage {...params} />;
}
